module.exports = __webpack_public_path__ + "img/outlander_feel.823bfba6.jpg";